const normalize = (value = "") => String(value).trim().toLowerCase().replace(/[^a-z0-9@.]/g, "");

export const getHouseholdReadiness = (household) => {
  const members = household.members || [];
  const players = household.players || [];
  const registrations = household.registrations || [];
  const missingContact = !members.some((member) => member.email || member.phone);
  const missingPlayerDetails = players.filter((player) => !player.date_of_birth).length;
  const missingDocuments = registrations.reduce((count, registration) => count + (registration.missing_documents?.length || 0), 0);
  return { missingContact, missingPlayerDetails, missingDocuments, ready: !missingContact && !missingPlayerDetails && !missingDocuments };
};

export const findDuplicateHouseholds = (households = []) => {
  const candidates = [];
  for (let left = 0; left < households.length; left += 1) {
    for (let right = left + 1; right < households.length; right += 1) {
      const first = households[left];
      const second = households[right];
      const firstEmails = new Set((first.members || []).map((member) => normalize(member.email)).filter(Boolean));
      const firstPhones = new Set((first.members || []).map((member) => normalize(member.phone)).filter(Boolean));
      const sharedEmail = (second.members || []).some((member) => firstEmails.has(normalize(member.email)));
      const sharedPhone = (second.members || []).some((member) => firstPhones.has(normalize(member.phone)));
      const firstPlayers = new Set((first.players || []).map((player) => `${normalize(player.first_name)}:${normalize(player.last_name)}:${player.date_of_birth || ""}`));
      const sharedPlayer = (second.players || []).some((player) => firstPlayers.has(`${normalize(player.first_name)}:${normalize(player.last_name)}:${player.date_of_birth || ""}`));
      const sameName = normalize(first.name) && normalize(first.name) === normalize(second.name);
      const reasons = [sharedEmail ? "guardian email" : null, sharedPhone ? "guardian phone" : null, sharedPlayer ? "player identity" : null, sameName ? "household name" : null].filter(Boolean);
      if (reasons.length) candidates.push({ id: `${first.household_id}:${second.household_id}`, first, second, reasons });
    }
  }
  return candidates;
};
